import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import React from 'react';
import { RadioGroup, RadioGroupOption } from '../FormControls/SelectControls';
import { PurePtr } from '@pure-ptr/react';

interface BulkActionConfirmationDialogProps {
    open: boolean;
    onClose: () => void;
    onConfirm: (processAll: boolean) => void;
    title: string;
    actionLabel: string;
    selectedCount: number;
    totalCount: number;
    currentPageCount: number;
    isPending?: boolean;
    processAllPtr: PurePtr<boolean>;
    customText?: string;
}

export const BulkActionConfirmationDialog = ({
    open,
    onClose,
    onConfirm,
    title,
    actionLabel,
    selectedCount,
    totalCount,
    currentPageCount,
    isPending = false,
    processAllPtr,
    customText
}: BulkActionConfirmationDialogProps) => {

    const handleConfirm = () => {
        onConfirm(processAllPtr.value);
    };

    const showProcessAllOption = selectedCount > 0 && currentPageCount > 0 && selectedCount === currentPageCount && totalCount > selectedCount;

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>
                {title || (selectedCount === 1 ? actionLabel : `${actionLabel} Multiple`)}
            </DialogTitle>
            <DialogContent>
                {selectedCount > 0 ? (
                    showProcessAllOption ? (
                        <RadioGroup 
                            valuePtr={processAllPtr} 
                            label={`Are you sure you want to ${actionLabel.toLowerCase()}?`}
                        >
                            <RadioGroupOption value={false}>
                                {selectedCount} selected records
                            </RadioGroupOption>
                            <RadioGroupOption value={true}>
                                All {totalCount} records 
                            </RadioGroupOption>
                        </RadioGroup>
                    ) : (
                        <DialogContentText>
                            {customText || (selectedCount === 1 
                                ? `Are you sure you want to ${actionLabel.toLowerCase()} this record?` 
                                : `Are you sure you want to ${actionLabel.toLowerCase()} ${selectedCount} records?`)}
                        </DialogContentText>
                    )
                ) : (
                    <DialogContentText>
                        No records selected, please select at least one record to {actionLabel.toLowerCase()}.
                    </DialogContentText>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={isPending}>
                    Cancel
                </Button>
                {selectedCount > 0 && (
                    <Button
                        onClick={handleConfirm}
                        disabled={isPending}
                        color="primary"
                        variant='contained'
                    >
                        {isPending ? 'Processing...' : (selectedCount === 1 ? actionLabel : `${actionLabel} Records`)}
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};
